// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"2a4ac533","324":"d7cca887","890":"704214d3","921":"766e8344"}[chunkId] + ".chunk.js";
};